import * as requestFromServer from "./notifyApis";
import i18n from 'i18next'
import { toastService } from "../../../component/common/toast-messages/toast";


// notify -> send notification api
export const sendPushNotificationAction = (dataToBeSent, navigate, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.sendPushNotification(dataToBeSent);
    if (response) {
      toastService.success(i18n.t("Modules.Notify.notificationSentSuccessfully"));
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

